export const BOOLEAN = {
  T: 'true',
  F: 'false'
};
